import { Component, Input, type OnInit } from '@angular/core';
import { ITableKey } from 'src/app/modules/shared/components/basic-table/basic-table.constants';
import { IInvestmentLine, IPolicyAsset } from 'src/app/modules/shared/models/policy.model';
import { CommonUtils } from 'src/app/utils/CommonUtils';
import { REBALANCE_INVESTMENTS_ASSETS_TABLE_TABLE_KEYS } from './rebalance-investments.constants';

@Component({
  selector: 'app-rebalance-investments',
  templateUrl: './rebalance-investments.component.html',
  styleUrl: './rebalance-investments.component.scss',
})
export class RebalanceInvestmentsComponent implements OnInit {

  @Input() rebalancedLine: IInvestmentLine
  @Input() operationCost: number;
  @Input() operationEffectDate: string; 
  lineAssets: IPolicyAsset[] = [];
  tableKeys: ITableKey[] = CommonUtils.assign(REBALANCE_INVESTMENTS_ASSETS_TABLE_TABLE_KEYS);
  actualInvestmentLineCode: string = '';
  actualInvestmentLineDescription: string = '';

  ngOnInit(): void {
    this.lineAssets = this.rebalancedLine.funds
    this.actualInvestmentLineCode = this.rebalancedLine.code;
    this.actualInvestmentLineDescription = this.rebalancedLine.description;
  }
}
